import React, { useEffect } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";

import userDefaultPerfil from "../../images/perfil2.png";

import { useDispatch, useSelector } from "react-redux";
import { singOut } from "../../redux/auth/actions";
import { withRouter } from "react-router";
// import { getAuth } from '../redux/auth/actions';

const SidebarClimate = (props) => {
  const dispatch = useDispatch();
  const userPic = useSelector((store) => store.auth.pic);
  const userN = useSelector((store) => store.auth.name);
  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);
  const userRoles = useSelector((store) => store.auth.userRoles);

  const onSignOut = (e) => {
    e.preventDefault();
    dispatch(singOut(props));
  };

  return (
    <>
      <ProSidebar
        collapsed={false}
        className={`custom-sidebar ${props.show ? "show-sidebar" : ""}`}
        toggled={"fixed"}
      >
        <SidebarContent style={{ overflowY: "auto" }}>
          <Menu iconShape="square">
            <MenuItem icon={<i className="material-icons">face</i>}>
              <Link to={`/detalle-empleado/${userId}/${userType}`}>
                Ficha de empleado
              </Link>
            </MenuItem>

            {userRoles.length > 0 && userRoles.includes("administrador") ? (
              <MenuItem icon={<i className="material-icons">emoji_objects</i>}>
                <Link to={`/categorias/`}>Categorias</Link>
              </MenuItem>
            ) : null}

            {userRoles.length > 0 && userRoles.includes("administrador") ? (
              <MenuItem
                icon={
                  <i className="material-icons">drive_file_rename_outline</i>
                }
              >
                <Link to={`/mediciones/`}>Mediciones</Link>
              </MenuItem>
            ) : null}

            {userRoles.includes("responsable") ||
            (userRoles.length > 0 && userRoles.includes("administrador")) ? (
              <MenuItem icon={<i className="material-icons">ballot</i>}>
                <Link to="/cuestionarios">Cuestionarios</Link>
              </MenuItem>
            ) : null}

            {/* {userRoles.length > 0 &&
            userRoles.includes("responsable") &&
            !userRoles.includes("administrador") ? (
              <MenuItem icon={<i className="material-icons">ballot</i>}>
                <Link to="/cuestionarios">Cuestionarios</Link>
              </MenuItem>
            ) : null} */}

            {userRoles.length > 0 && userRoles.includes("administrador") ? (
              <MenuItem icon={<i className="material-icons">group_add</i>}>
                <Link to="/segmentación">Segmento</Link>
              </MenuItem>
            ) : null}

            {userRoles.length > 0 &&
            userRoles.includes("responsable") &&
            !userRoles.includes("administrador") ? (
              <MenuItem icon={<i className="material-icons">group_add</i>}>
                <Link to="/segmentación">Segmento</Link>
              </MenuItem>
            ) : null}

            {userRoles.length > 0 && userRoles.includes("administrador") ? (
              <MenuItem icon={<i className="material-icons">construction</i>}>
                <Link to={`/herramienta/`}>Herramienta</Link>
              </MenuItem>
            ) : null}

            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("responsable")) ? (
              <MenuItem icon={<i className="material-icons">campaign</i>}>
                <Link to={`/campaña`}>Campaña</Link>
              </MenuItem>
            ) : null}

            {userRoles.length > 0 && userRoles.includes("administrador") ? (
              <MenuItem icon={<i className="material-icons">dvr</i>}>
                <Link to={`/clima-laboral/log`}>Registro actividades</Link>
              </MenuItem>
            ) : null}

            {/* {userRoles.length > 0 && 
              (userRoles.find(opt => opt.toString().toLowerCase() === 'administrador'
            )!==undefined)?(
              <MenuItem icon={<i className="material-icons">help_center</i>}><Link to={`/TipoPregunta/`}>Tipo de pregunta</Link></MenuItem>
              ):null
            } */}
          </Menu>
        </SidebarContent>
      </ProSidebar>
      <div
        onClick={() => props.onShowSidebar()}
        className={`overlay ${props.show ? "show-overlay" : ""}`}
      ></div>
    </>
  );
};

export default withRouter(SidebarClimate);
